var React = require('react');

function DiscountCode (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"fill":"#F5F5F5","cx":"40","cy":"40","r":"40","key":0}),React.createElement("g",{"strokeLinecap":"round","strokeLinejoin":"round","key":1},[React.createElement("path",{"d":"M37.154 60.803l18.86-18.86A6.782 6.782 0 0 0 58 37.148V26.392A3.391 3.391 0 0 0 54.61 23H43.854c-1.8 0-3.525.714-4.797 1.986l-18.86 18.86A4.087 4.087 0 0 0 19 46.736v.006c0 1.084.43 2.123 1.197 2.89l11.171 11.171A4.087 4.087 0 0 0 34.258 62h.006c1.084 0 2.123-.43 2.89-1.197z","stroke":"#7091F2","fill":"#FFF","key":0}),React.createElement("path",{"d":"M51 33.5a3.5 3.5 0 1 1-6.999.001A3.5 3.5 0 0 1 51 33.5z","stroke":"#A9B0B7","fill":"#F5F5F5","key":1})])]));
}

DiscountCode.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80"};

module.exports = DiscountCode;

DiscountCode.default = DiscountCode;
